import { CSSProperties } from 'react';

import { PreviewWidth, PreviewHeight } from './constants';

export const transtionGroupStyles: CSSProperties = {
  perspective: 1200,
  position: 'relative',
  overflow: 'hidden',
  width: PreviewWidth,
  height: PreviewHeight,
};

export const itemStyles: CSSProperties = {
  position: 'absolute',
  display: 'inline-block',
  opacity: 1,
  transform: 'translate3d(0, 0, 0)',
  transformStyle: 'preserve-3d',
  backfaceVisibility: 'hidden',
  width: PreviewWidth,
};
